import { defineMessages } from 'react-intl';

export default defineMessages({
  close: {
    id: 'baukasten.Banner.close',
    defaultMessage: 'Close',
  },
});
